import { Component, input, model } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { AssertionIssue, Media } from "../../../../core/database/db";
import { AssertionImageGalleryComponent } from "../../../media/components/assertion-image-gallery/assertion-image-gallery.component";

/**
 * Presentational card for a single assertion issue.
 *
 * Renders the issue text and its photos (via the shared `app-assertion-image-gallery`, which opens the
 * full-screen viewer on tap), with an optionally visible checkbox. When the checkbox is shown the whole
 * card is a toggle target (tap on mobile / click on desktop); when it is hidden the card is inert.
 */
@Component({
  selector: "app-issue-card",
  standalone: true,
  imports: [FormsModule, CheckboxModule, AssertionImageGalleryComponent],
  templateUrl: "./issue-card.component.html",
  styleUrl: "./issue-card.component.scss"
})
export class IssueCardComponent {
  /** The issue to display. */
  issue = input.required<AssertionIssue>();
  /** The issue's photos; rendered read-only via the shared image gallery. */
  media = input<Media[]>([]);
  /** Show the selection checkbox and make the card clickable. */
  showCheckbox = input<boolean>(false);
  /** Highlight the checkbox in a danger/invalid state (e.g. required-selection validation). */
  invalid = input<boolean>(false);
  /** Two-way selection state (only meaningful when `showCheckbox` is true). */
  selected = model<boolean>(false);
  testId = input<string>("app-issue-card");

  protected toggleSelected(): void {
    if (!this.showCheckbox()) {
      return;
    }
    this.selected.set(!this.selected());
  }
}
